import { createRouter, createWebHistory, RouteRecordRaw } from 'vue-router'

export default function (routes: RouteRecordRaw[]) {
  const router = createRouter({
    history: createWebHistory(),
    routes,
  })
  return router
}
